import React from 'react';
import clsx from 'clsx';

import formStyles from '../styles.module.scss';

import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  const classNames = clsx(styles.skeleton, formStyles.newCandidateId);
  return (
    <React.Fragment>
      <span data-nosnippet className="visuallyHidden">
        Loading add your candidate number
      </span>
      <div className={classNames} aria-hidden="true">
        <span>
          <p></p>
          <p></p>
        </span>
        <div>
          <span></span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Skeleton;
